import {Injectable, inject} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {EventsManager} from '../../events/events.manager';

@Injectable()

export class LoadingInterceptor implements HttpInterceptor {
  private _eventsManager: EventsManager = inject(EventsManager);

  private _totalRequests: number = 0;

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this._totalRequests++;
    this._eventsManager.setLoadingState(true);
    return next.handle(request).pipe(
      finalize((): void => {
        this._totalRequests--;
        if (this._totalRequests == 0) {
          this._eventsManager.setLoadingState(false);
        }
      })
    );
  }
}
